import recorte_png from "../images/recorte.png";

export default function RecorteGast() {
  return <img width="50px" src={recorte_png}></img>;
}
